import { type FilterConfig } from '../interfaces';

import { tagFilterConfigMultiple } from './default-config-multiple';

export const tagFilterConfigSingle: FilterConfig = {
  ...tagFilterConfigMultiple,
  multiple: false,
};
